export const LeftMenuViewStyles = ({
  theme: {icons, colors, fonts, shadows},
}) => {
  return {
    toggleIcon: icons.ExpandCollapse,
    sm: {
      viewContainer: {
        backgroundColor: colors.BACKGROUND,
        marginTop: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
    md: {
      menuBarWidth: 250,
      collapsedMenuBarWidth: 30,
      viewContainer: {
        backgroundColor: colors.BACKGROUND,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderRadius: 6,
      },
      collapseView: {
        backgroundColor: colors.SURFACE3,
      },
    },
    menuBarContainer: {
      backgroundColor: 'transparent',
    },
    menuBarScrollView: {
      padding: 8,
      paddingTop: 0,
      gap: 6,
    },
    menuItemContainer: {
      borderRadius: 6,
      paddingLeft: 8,
      paddingRight: 8,
      borderWidth: 1,
      borderColor: 'transparent',
    },
    menuItemContainerHoverColor: 'transparent',
    itemLabelHoverColor: colors.BRAND_HIGH,
    selectedMenuItemContainer: {
      backgroundColor: colors.BACKGROUND,
      borderWidth: 1,
      borderColor: colors.BRAND_LOW,
    },
    menuDot: {
      backgroundColor: colors.OUTLINE,
    },
    selectedMenuDot: {
      backgroundColor: colors.BRAND_UPPER_MEDIUM,
    },
    menuDotHoverColor: colors.BRAND_UPPER_MEDIUM,
    menuItemRowContainer: {
      height: 36,
      gap: 8,
      alignItems: 'center',
    },
    menuItemLabel: {
      color: colors.NEUTRAL_HIGH,
      ...fonts.BODY2,
    },
    selectedMenuItemLabel: {
      color: colors.BRAND_HIGH,
    },
    countContainer: {},
    countText: {
      color: colors.NEUTRAL_MEDIUM,
      ...fonts.CAPTION_LARGE,
    },
    hoverCountTextColor: colors.BRAND_HIGH,
    selectedCountText: {
      color: colors.BRAND_HIGH,
    },
    topGroupContainer: {
      borderRadius: 4,
      padding: 4,
      ...shadows.M,
    },
    groupContainer: {
      borderTopWidth: 1,
      borderTopColor: colors.OUTLINE,
    },
    sectionContainer: {
      borderRadius: 6,
    },
    sectionMenuItemContainer: {
      marginLeft: 16,
    },
    selectedSectionContainer: {
      backgroundColor: colors.BACKGROUND,
    },
    sectionItemContainerHoverColor: 'transparent',
    sectionItemContainer: {
      height: 36,
      gap: 8,
      alignItems: 'center',
      paddingLeft: 8,
      paddingRight: 8,
      borderRadius: 6,
    },
    sectionItemLabel: {
      color: colors.NEUTRAL_HIGH,
      ...fonts.BODY2,
    },
    selectedSectionItemLabel: {
      color: colors.BRAND_HIGH,
    },
    sectionItemLabelHoverColor: colors.BRAND_HIGH,
    toggleButton: {
      ...shadows.L,
      backgroundColor: colors.SURFACE3,
    },
  };
};

export const FloatingHelpButtonStyes = ({
  theme: {icons, colors, fonts, shadows},
}) => {
  return {
    helpIcons: icons.HelpIcons,
    helpCharacterIcons: icons.HelpCharacterIcon,
    helpGuideCharacterIcons: icons.HelpGuideCharacterIcon,
    sm: {
      floatingButtonContainer: {
        position: 'absolute',
        bottom: '0',
        right: '0',
      },
    },
    md: {
      floatingButtonContainer: {
        position: 'absolute',
        bottom: '0',
        right: '0',
      },
    },
  };
};
